import { FC } from 'react'

import { Cluster, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { ShipmentDetailTitleSkeleton } from './detailsSkeleton'

const ShipmentDocumentsMainSkeleton: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Stack gap={24}>
      <Skeleton variant="content" size={16} fullWidth />
      <Cluster gap={8} y="center">
        <Skeleton variant="badge" />
        <Skeleton variant="badge" />
      </Cluster>
      <Table
        columns={[
          {
            accessorKey: 'name',
            header: translate('documents.table.name'),
            cell: () => <Skeleton variant="content" />,
          },
          {
            accessorKey: 'version',
            header: translate('documents.table.version'),
            cell: () => <Skeleton variant="content" />,
          },
          {
            accessorKey: 'date',
            header: translate('documents.table.date'),
            cell: () => <Skeleton variant="content" />,
          },
          {
            accessorKey: 'uploaded',
            header: translate('documents.table.uploaded'),
            cell: () => <Skeleton variant="content" />,
          },
          {
            accessorKey: 'actions',
            header: '',
            cell: () => (
              <Cluster gap={8} fullWidth x="end">
                <Skeleton variant="icon" />
                <Skeleton variant="icon" />
                <Skeleton variant="icon" />
                <Skeleton variant="icon" />
              </Cluster>
            ),
          },
        ]}
        data={[{}]}
        footless
      />
    </Stack>
  )
}

export const ShipmentDocumentsSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<WidgetSkeleton count={2} />}
      navigation={<Back to="/" />}
      main={<ShipmentDocumentsMainSkeleton />}
      footer={<Footer />}
    />
  )
}
